var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconEditorListBulletTimes = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("path", { d: "M12.7,5.5h14.1" }),
            React.createElement("path", { d: "M26.4,10.8L12.7,24.5" }),
            React.createElement("path", { d: "M12.7,10.8l13.7,13.7" }),
            React.createElement("path", { strokeWidth: "4", d: "M4.2,5.5L4.2,5.5" }),
            React.createElement("path", { strokeWidth: "4", d: "M4.2,15L4.2,15" }),
            React.createElement("path", { strokeWidth: "4", d: "M4.2,24.5L4.2,24.5" }))));
});
export default IconEditorListBulletTimes;
//# sourceMappingURL=IconEditorListBulletTimes.js.map